var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer",class:{ stopped: !_vm.playing, playing: _vm.playing }},[_vm._v(_vm._s(_vm.formated_current_time))])}
var staticRenderFns = []

export { render, staticRenderFns }